<template>
  <div class="locale-select">
    {{$t('localeSelect.lang')}}
    <b-dropdown no-caret variant="-ternary btn--outline">
      <template #button-content>
        <span :class="'lang lang-'+selected.locale"></span>{{selected.text}}
      </template>
      <b-dropdown-item v-for="item in langs" :key="item.lang" href="#" @click="selectLocale(item.locale)"><span :class="'lang lang-'+item.locale"></span>{{item.text}}</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  export default {
    name: 'locale-select',
    components: {
    },
    props: {
      // triggerStyle: {
      //   type: Object,
      //   require: false
      // }
    },
    data() {
      return {
        langs: [
          {locale: 'ru', text: 'Русский'},
          {locale: 'en', text: 'English'},
        ]
      }
    },
    computed: {
      selected() {
        return this.langs.find(lang => {
          return lang.locale === this.$locale.current();
        });
      }
    },
    methods: {
      selectLocale(locale) {
        this.$locale.change(locale);
        window.location.reload();
      }
    }
  }
</script>

<style lang="scss">
  //Flags from https://github.com/hjnilsson/country-flags
  .locale-select {
    .lang {
      display: inline-block;
      height: 30px;
      width: 30px;
      background-size:     contain;
      background-repeat:   no-repeat;
      background-position: center center;
      margin-left: 10px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .lang-ru{
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E%3Crect fill='%23fff' width='9' height='3'/%3E%3Crect fill='%23d52b1e' y='3' width='9' height='3'/%3E%3Crect fill='%230039a6' y='2' width='9' height='2'/%3E%3C/svg%3E%0A");
    }
    .lang-en{
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3E%3Crect width='7410' height='3900' fill='%23b22234'/%3E%3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E%3Crect width='2964' height='2100' fill='%233c3b6e'/%3E%3Cg fill='%23fff'%3E%3Cg id='s18'%3E%3Cg id='s9'%3E%3Cg id='s5'%3E%3Cg id='s4'%3E%3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E%3Cuse xlink:href='%23s' y='420'/%3E%3Cuse xlink:href='%23s' y='840'/%3E%3Cuse xlink:href='%23s' y='1260'/%3E%3C/g%3E%3Cuse xlink:href='%23s' y='1680'/%3E%3C/g%3E%3Cuse xlink:href='%23s4' x='247' y='210'/%3E%3C/g%3E%3Cuse xlink:href='%23s9' x='494'/%3E%3C/g%3E%3Cuse xlink:href='%23s18' x='988'/%3E%3Cuse xlink:href='%23s9' x='1976'/%3E%3Cuse xlink:href='%23s5' x='2470'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
    .dropdown-toggle {
      padding: 0 10px 0 0;
      border: none;
      font-weight: 400;
    }
    .dropdown-item {
      text-decoration: none;
    }
  }
</style>
